import { ChannelCodeEnum } from "app/modules/manage/workflow/recruit/candidate/constants";

export enum CallBackActionColumn {
    VIEW_CV = 'VIEW_CV',
    VIEW_DATA_AI = 'VIEW_DATA_AI',
    VIEW_ATTACHMENT = 'VIEW_ATTACHMENT'
}

export enum ApproveType {
    AI = "AI",
    DEFAULT = "DEFAULT"
}

export enum CandidateStatusEnum {
    OPENING = 'OPENING',
    PROCESSING = 'PROCESSING',
    OFFERED = 'OFFERED',
    EMPLOYEE = 'EMPLOYEE',
    BACKLIST = 'BACKLIST',
}

export enum ApproveAction {
    ONLINE_CANDIDATE = 'ONLINE_CANDIDATE',
    REQUISITION_CANDIDATE = 'REQUISITION_CANDIDATE',
}

export const SOCIAL_OBJECT_FIELDS = {
    "facebook": ChannelCodeEnum.Facebook,
    "github": ChannelCodeEnum.Github,
    "linkedin": ChannelCodeEnum.LinkedIn,
    "porfolioLink": ChannelCodeEnum.Portfolio,
    "behance": ChannelCodeEnum.Behance,
    "otherPortfolio": 'otherPortfolio'
}

export enum ResumeCandidateStatus {
    REJECT = "REJECT",
    APPROVE = "APPROVE",
}